import { createAsyncThunk } from "@reduxjs/toolkit";
import { putAdminPageNote } from "@/lib/api-server/admin/page/note/putAdminPageNote";
import { IAdminSlice } from "@/redux/slices/admin/types";

export const addComment = createAsyncThunk(
  "admin/addComment",
  async (
    {
      uuid,
      comment,
    }: {
      uuid: string;
      comment: string;
    },
    { rejectWithValue }
  ) =>
    await putAdminPageNote(uuid, comment).then((r) => {
      if (!r.success) return rejectWithValue(r.error);
      return r.data;
    })
);

const pending = (
  state: IAdminSlice,
  {
    meta: {
      arg: { uuid, comment },
    },
  }
) => {
  state.pages = state.pages.map((page: any) => {
    if (page.uuid === uuid) {
      return {
        ...page,
        loading: true,
      };
    }
    return page;
  });
};

const rejected = (
  state: IAdminSlice,
  {
    meta: {
      arg: { uuid, comment },
    },
  }
) => {
  state.pages = state.pages.map((page: any) => {
    if (page.uuid === uuid) {
      return {
        ...page,
        loading: false,
      };
    }
    return page;
  });
};

const fulfilled = (
  state: IAdminSlice,
  {
    payload,
    meta: {
      arg: { uuid },
    },
  }: { payload: any; meta: any }
) => {
  state.pages = state.pages.map((page: any) => {
    if (page.uuid === uuid) {
      return {
        ...page,
        notes: [...page.notes, payload],
        notes_length: page.notes_length + 1,
        loading: false,
      };
    }
    return page;
  });
};

export default {
  action: addComment,
  pending,
  rejected,
  fulfilled,
};
